import React from 'react';
import DialogContent from "@mui/material/DialogContent";
import TextField from "../../../../components/form/TextField";
import Dialog from "../../../../components/Dialog";
import SingleFieldForm from "../common/SingleFieldForm";
import * as Yup from "yup";
import { Stack } from "@mui/material";

const ProductionPriceEditionDialog: React.FC<ProductionPriceEditionDialogProps> = props => {
    return (
        <Dialog
            open={ true }
            onCloseClick={ props.onClose }
            title='Edytuj cenę za druk + montaż dla zaznaczonych nośników'
        >
            <DialogContent sx={ { minWidth: '500px' } }>
                <Stack spacing={ 4 } pt={ 2 }>
                    <SingleFieldForm
                        fieldName='productionPriceByAbsoluteValue'
                        schema={ Yup.number().required() }
                        onSubmit={ props.onSubmit }
                    >
                        <TextField
                            name='productionPriceByAbsoluteValue'
                            label='Wartość w PLN'
                            helperText='Cena nie może być niższa niż koszt'
                            fullWidth
                            size='small'
                            type='number'
                            inputProps={ { min: 0 } }
                        />
                    </SingleFieldForm>
                    <SingleFieldForm
                        fieldName='productionPriceByAddedPercent'
                        onSubmit={ props.onSubmit }
                        schema={ Yup.number().required().min(
                            1,
                            'Procent musi być większy od 0'
                        ) }
                    >
                        <TextField
                            name='productionPriceByAddedPercent'
                            label='Marża procentowa'
                            fullWidth
                            size='small'
                            type='number'
                            inputProps={ { min: 1 } }
                        />
                    </SingleFieldForm>
                    <SingleFieldForm
                        fieldName='productionPriceByAddedValue'
                        onSubmit={ props.onSubmit }
                        schema={ Yup.number().required().min(
                            1,
                            'Wartość musi być większa od 0'
                        ) }
                    >
                        <TextField
                            name='productionPriceByAddedValue'
                            label='Marża kwotowa'
                            fullWidth
                            size='small'
                            type='number'
                            inputProps={ { min: 1 } }
                        />
                    </SingleFieldForm>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
export default ProductionPriceEditionDialog;

export interface ProductionPriceEditionDialogProps {
    readonly onSubmit: (value: Value) => Promise<any>;
    readonly onClose: () => any;
}

type Value =
    { productionPriceByAbsoluteValue: number } |
    { productionPriceByAddedPercent: number } |
    { productionPriceByAddedValue: number };
